import { Link } from "react-router-dom";
import { siteStats } from "@/mocks/timeline";

const Hero = () => (
  <section className="relative w-full overflow-hidden">
    <div className="absolute inset-0">
      <img
        src="https://readdy.ai/api/search-image?query=vintage%20archive%20room%20interior%20with%20tall%20wooden%20shelves%20of%20labeled%20boxes%2C%20stacked%20film%20reels%20and%20bundled%20old%20newspapers%2C%20warm%20amber%20light%20rays%20with%20floating%20dust%2C%20deep%20brick%20red%20and%20aged%20gold%20color%20grading%2C%20moody%20cinematic%20atmosphere%2C%20artistic%20stylized%2C%20no%20people&width=1600&height=900&seq=arch-hero-2026&orientation=landscape"
        alt="堆满旧报纸与胶片盒的档案室，象征娱乐往事的整理现场"
        title="考古坞 · 娱乐往事档案室"
        className="h-full w-full object-cover object-top"
      />
      <span className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/70 to-foreground-950/40"></span>
    </div>

    <div className="relative mx-auto max-w-shell px-4 pb-14 pt-16 md:px-6 md:pb-20 md:pt-24">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <p className="flex items-center gap-3 font-label text-xs tracking-[0.3em] text-accent-400 rise-in">
            <span className="h-px w-10 bg-accent-400"></span>
            娱乐往事档案室 · 2000 — 2026
          </p>
          <h1 className="mt-5 font-heading text-3xl font-black leading-[1.15] text-background-50 rise-in md:text-5xl">
            <span className="block font-label text-sm font-normal tracking-[0.4em] text-background-300">
              考古坞
            </span>
            <span className="mt-3 block">旧料翻出，</span>
            <span className="block text-accent-400">年代重看。</span>
          </h1>
          <p className="mt-6 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
            把过去二十多年里被时间盖住的娱乐旧事，一条一条翻出来重新整理。选秀记忆、影视旧账、
            乐坛回响、网络初代——按年代归档，附上出处，冷静地把故事讲完。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/archive"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-archive-line text-base"></i>
              进入考古合集
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 px-7 py-3 font-label text-sm text-background-100 transition-colors hover:bg-background-100/10"
            >
              我们怎么整理旧料
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="rounded-lg border border-background-100/20 bg-foreground-950/45 p-5 backdrop-blur-sm md:p-6">
            <p className="flex items-center justify-between font-label text-xs tracking-[0.2em] text-accent-400">
              <span>本期档案卡</span>
              <span>第 199 期</span>
            </p>
            <div className="mt-4 space-y-4">
              <div className="flex gap-3 border-b border-background-100/15 pb-4">
                <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                  <i className="ri-mic-line text-base"></i>
                </span>
                <div>
                  <p className="font-heading text-sm font-bold text-background-50">
                    选秀往事：被遗忘的第六名
                  </p>
                  <p className="mt-1 font-label text-xs text-background-300">
                    淘汰夜没唱完的八秒
                  </p>
                </div>
              </div>
              <div className="flex gap-3 border-b border-background-100/15 pb-4">
                <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                  <i className="ri-live-line text-base"></i>
                </span>
                <div>
                  <p className="font-heading text-sm font-bold text-background-50">
                    综艺名场面：没剪掉的三分钟
                  </p>
                  <p className="mt-1 font-label text-xs text-background-300">
                    导播在最后两秒改了主意
                  </p>
                </div>
              </div>
              <div className="flex gap-3">
                <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                  <i className="ri-music-2-line text-base"></i>
                </span>
                <div>
                  <p className="font-heading text-sm font-bold text-background-50">
                    乐坛回响：躺了二十年的 demo
                  </p>
                  <p className="mt-1 font-label text-xs text-background-300">
                    外壳上写着「不寄了」
                  </p>
                </div>
              </div>
            </div>
            <Link
              to="/archive"
              className="mt-6 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-accent-500/60 px-4 py-2.5 font-label text-sm text-accent-400 transition-colors hover:bg-accent-500 hover:text-primary-950"
            >
              查看全部归档
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>
        </div>
      </div>
    </div>

    <div className="relative border-t border-background-100/15 bg-foreground-950/70 backdrop-blur-sm">
      <div className="mx-auto grid max-w-shell grid-cols-2 gap-x-6 gap-y-6 px-4 py-7 md:grid-cols-4 md:px-6">
        {siteStats.map((stat) => (
          <div key={stat.label} className="flex items-baseline gap-2">
            <span className="font-heading text-2xl font-black text-secondary-300 md:text-3xl">
              {stat.value}
            </span>
            <span className="font-label text-xs text-background-300">
              {stat.label}
              <span className="ml-1 text-background-400">/{stat.unit}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Hero;